module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Download_16"],"path":[{"$":{"d":"M12.5,5,8,11,3.5,5H6V1h4V5ZM5,13H3v2H5Zm4,0H7v2H9Zm4,0H11v2h2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Download_16.svg
// module id = npil
// module chunks = 1